/*
      ___           ___
     /\  \         /\  \
    /::\  \       /::\  \
   /:/\:\  \     /:/\ \  \
  /::\ \:\  \   _\:\ \ \  \
 /:/\:\ \:\__\ /\ \:\ \ \__\
 \/_|::\/:/  / \:\ \:\ \/__/
    |:|::/  /   \:\ \:\__\
    |:|\/__/     \:\/:/  /
    |:|  |        \::/  /
     \|__|         \/__/

    Developed by Ralph Shippam - 2019.
*/

import {NgModule, ModuleWithProviders} from '@angular/core';
import {CommonModule} from '@angular/common';
import {
    RSValidatorDirective,
    RSValidErrorComponent,
    RSValidatorFormDirective,
    RSValidatorFormSubmitDirective,
    RSValidatorSubFormDirective,
    RSValidatorSubFormClass
} from './rsvalidator.directive';
import {RSValidatorService} from './rsvalidator.service';
import {MatFormFieldModule} from '@angular/material/form-field';

@NgModule({
    imports: [
        CommonModule,
        MatFormFieldModule
    ],
    declarations: [RSValidatorDirective, RSValidErrorComponent,
                   RSValidatorFormDirective, RSValidatorSubFormDirective,
                   RSValidatorFormSubmitDirective, RSValidatorSubFormClass],
    exports: [RSValidatorDirective, RSValidatorFormDirective,
              RSValidatorSubFormDirective, RSValidatorFormSubmitDirective,
              RSValidatorSubFormClass],
})
export class RSValidatorModule {
    constructor() {}
    static forRoot(): ModuleWithProviders<RSValidatorModule> {
        // TODO: NG Only allows static here so we cannot pass in the rules? rules?: RSValidator.Rules - this.validator?
        return {
            ngModule: RSValidatorModule,
            providers: [RSValidatorDirective, RSValidatorFormDirective, RSValidatorService],
        };
    }
}
